import React from 'react'

import { Subtitle } from 'components/Typography'
import checkmark from 'images/checkmark.svg'
import { Flex } from 'reflexbox/styled-components'

const PasswordFormatValidation = password => {
  const minLength = password.length >= 6
  const hasLetter = password.match(/\w*[A-Za-z]\w*/)?.length
  const hasNumber = password.match(/\w*[0-9]\w*/)?.length

  return (
    <Flex justifyContent='flex-start' mb='32px'>
      <Flex flexDirection='column' mr='16px'>
        <Subtitle color={minLength ? 'success' : 'grays.N500'}>
          {minLength ? <img src={checkmark} /> : '•'} Mínimo de seis caracteres
        </Subtitle>
        <Subtitle color={hasNumber ? 'success' : 'grays.N500'}>
          {hasNumber ? <img src={checkmark} /> : '•'} Um número
        </Subtitle>
        <Subtitle color={hasLetter ? 'success' : 'grays.N500'}>
          {hasLetter ? <img src={checkmark} /> : '•'} Uma letra
        </Subtitle>
      </Flex>
    </Flex>
  )
}

export default PasswordFormatValidation
